// extracted by mini-css-extract-plugin
export default {"cls1":"VeloMenu-Divider_cls1__fsfgS","cls2":"VeloMenu-Divider_cls2__zQ014 VeloMenu-Divider_cls1__fsfgS"};